import cn from "classnames";
import React, { ReactNode, useEffect } from "react";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PanelWembii } from "../component/PanelWembii";

export type CenterModalSize = "sm" | "md";

interface Props {
  children: ReactNode;
  active: boolean;
  visible: boolean;
  onClose: () => void;
  /** sm ≈ primera empresa (solo nombre); md = formulario completo */
  size?: CenterModalSize;
}

export default function CenterModal(props: Props) {
  const intl = useIntl();
  const {
    children,
    active,
    visible,
    onClose,
    size = "md",
  } = props;

  useEffect(() => {
    if (!visible) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [visible]);

  useEffect(() => {
    if (!visible) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [visible, onClose]);

  if (!active) return null;

  return (
    <div
      className={cn("center-modal", { "center-modal--open": visible })}
      aria-hidden={!visible}
    >
      {visible && (
        <>
          <button
            type="button"
            className="center-modal__backdrop"
            onClick={onClose}
            aria-label={intl.formatMessage({ id: "app.modal.close" })}
          />
          <div
            className="center-modal__shell"
            role="dialog"
            aria-modal="true"
          >
            <PanelWembii
              shadow
              rounded="20px"
              className={cn("center-modal__panel", {
                "center-modal__panel--sm": size === "sm",
                "center-modal__panel--md": size === "md",
              })}
            >
              <div className="center-modal__header">
                <button
                  type="button"
                  className="center-modal__close"
                  onClick={onClose}
                  aria-label={intl.formatMessage({ id: "app.modal.close" })}
                >
                  <FontAwesomeIcon icon={["fas", "times"]} />
                </button>
              </div>
              <div className="center-modal__body">{children}</div>
            </PanelWembii>
          </div>
        </>
      )}
    </div>
  );
}
